import { r2 } from "@/lib/format";

export const GST_RATE = 0.18;

export function computeItem(it) {
  const gross = r2(Number(it.qty || 0) * Number(it.unit_price || 0));
  if (it.gst_inclusive) {
    const taxable = r2(gross / (1 + GST_RATE));
    return { taxable, gst: r2(gross - taxable), line_total: gross };
  }
  const gst = r2(gross * GST_RATE);
  return { taxable: gross, gst, line_total: r2(gross + gst) };
}
